export default __webpack_public_path__ + "b7e5eff152eb0febbfae3e8a735763023aac9455/dd310f1c73ee98664ba9acf92580b449.png";